import React, { useCallback, useEffect, useState } from 'react';
import { Form, Modal } from 'react-bootstrap-5';
import Button from 'shared/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignature } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';

export default function OnMarketDisclaimer({ address, disclaimerText, name, signerId }) {
  const [isOpen, setIsOpen] = useState(false);
  const [hasSignedDisclaimer, setHasSignedDisclaimer] = useState(false);
  const [agreedToTerms, setAgreedToTerms] = useState(false);

  const showModal = () => setIsOpen(true);
  const hideModal = () => setIsOpen(false);

  function cancelSigning() {
    hideModal();
    setAgreedToTerms(false);
    setHasSignedDisclaimer(false);
  }

  function signDisclaimer() {
    setHasSignedDisclaimer(true);
    hideModal();
    document.querySelector('.submitLink').click();
  }

  useEffect(() => {
    document.addEventListener('show_disclaimer', showModal);

    return () => document.removeEventListener('show_disclaimer', showModal);
  }, []);

  const setTextareaHeight = useCallback((node) => {
    if (node !== null) {
      node.style.height = `${node.scrollHeight + 2}px`;
    }
  }, []);

  function dateTimeFormatted(options) {
    const now = new Date();
    const formatter = new Intl.DateTimeFormat('en-US', options);
    return formatter.format(now);
  }

  function formattedDate() {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return dateTimeFormatted(options);
  }

  function formattedTime() {
    const options = { hour: 'numeric', minute: '2-digit', hour12: true };
    return dateTimeFormatted(options);
  }

  return (
    <React.Fragment>
      {createPortal(
        <React.Fragment>
          {hasSignedDisclaimer ? (
            <React.Fragment>
              <input
                name="property[signed_on_market_disclaimers_attributes][0][disclaimer_text]"
                type="hidden"
                value={disclaimerText}
              />
              <input
                name="property[signed_on_market_disclaimers_attributes][0][signer_id]"
                type="hidden"
                value={signerId}
              />
            </React.Fragment>
          ) : null
          }
        </React.Fragment>,
        document.getElementById('on-market-disclaimer')
      )}

      <Modal show={isOpen} onHide={hideModal}>
        <Modal.Header>
          <div className="d-flex align-items-center gap-2">
            <FontAwesomeIcon className="icon-gradient me-2" icon={faSignature} size="lg" />
            <Modal.Title>Sign Disclaimer To Go On Market</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="form-vertical-field-container">
            <textarea className="form-control form-group" disabled ref={setTextareaHeight} value={disclaimerText}/>

            <div className="form-group">
              <label className="form-label">Address</label>
              <input className="form-control" disabled type="text" value={address}/>
            </div>

            <div className="form-group">
              <label className="form-label">Name</label>
              <input className="form-control" disabled type="text" value={name}/>
            </div>

            <div className="d-flex justify-content-between flex-wrap">
              <Form.Check
                checked={agreedToTerms}
                id="on-market-disclaimer-agree"
                label="I have read and agree to the Terms"
                type="checkbox"
                onChange={() => setAgreedToTerms(!agreedToTerms)}
              />

              {agreedToTerms && <span className="text-muted">Signed {formattedDate()} at {formattedTime()}</span>}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button.Primary
            disabled={hasSignedDisclaimer}
            plain
            onClick={cancelSigning}
          >
            Cancel
          </Button.Primary>
          <Button.Primary disabled={!agreedToTerms || hasSignedDisclaimer} onClick={signDisclaimer}>
            Sign Disclaimer
          </Button.Primary>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}

export const onMarketDisclaimerProps = {
  address: PropTypes.string,
  disclaimerText: PropTypes.string,
  name: PropTypes.string,
  signerId: PropTypes.number
};

OnMarketDisclaimer.propTypes = onMarketDisclaimerProps;
